import { useState } from "react";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg } from "@/lib/api";

export const ThankYouEditor = ({ cat, onSaved }) => {
  const [note, setNote] = useState(cat.thank_you || "");
  const [preview, setPreview] = useState("");
  const [busy, setBusy] = useState("");

  const run = async (key, fn) => {
    setBusy(key);
    try {
      await fn();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy("");
    }
  };
  const draft = () => run("draft", async () => setNote((await api.post(`/categories/${cat.id}/thank-you/draft`)).data.thank_you));
  const save = () => run("save", async () => {
    await api.put(`/categories/${cat.id}/thank-you`, { thank_you: note });
    toast.success(note.trim() ? `Thank-you note saved — it goes into every ${cat.name} delivery email` : "Thank-you note removed");
    onSaved();
  });
  const show = () => run("preview", async () => setPreview((await api.post(`/categories/${cat.id}/email-preview`, { thank_you: note })).data.html));

  return (
    <div className="bg-[#FAF7F0] border border-[#2A2325]/10 p-3 mt-2 space-y-3" data-testid={`thank-you-editor-${cat.id}`}>
      <div className="text-xs text-[#5C5255]">
        A personal note added to every delivery email for this category. Use <code className="bg-white px-1">{"{first_name}"}</code> and <code className="bg-white px-1">{"{title}"}</code> to personalise it.
      </div>
      <Textarea rows={5} value={note} maxLength={1500} onChange={(e) => { setNote(e.target.value); setPreview(""); }} placeholder={"Dear {first_name}, thank you for choosing {title}…"} className="bg-white text-sm font-body-serif" data-testid={`thank-you-input-${cat.id}`} />
      <div className="flex flex-wrap gap-2">
        <Button size="sm" variant="outline" className="rounded-none gap-1.5 bg-transparent" onClick={draft} disabled={!!busy} data-testid={`thank-you-draft-btn-${cat.id}`}><Sparkles size={13} />{busy === "draft" ? "Writing…" : "Draft with AI"}</Button>
        <Button size="sm" variant="outline" className="rounded-none bg-transparent" onClick={show} disabled={!!busy} data-testid={`thank-you-preview-btn-${cat.id}`}>{busy === "preview" ? "Loading…" : "Preview email"}</Button>
        <Button size="sm" className="rounded-none flex-1" onClick={save} disabled={!!busy} data-testid={`thank-you-save-btn-${cat.id}`}>{busy === "save" ? "Saving…" : "Save note"}</Button>
      </div>
      {preview && <iframe title="Email preview" srcDoc={preview} className="w-full h-[420px] bg-white border border-[#2A2325]/10" data-testid={`thank-you-preview-${cat.id}`} />}
    </div>
  );
};
